




































import { Mobile } from "@/mixins/mobile";
import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
@Component
export default class Search extends Mixins(Mobile) {
  @Prop({ default: "Enter search term..." }) placeholderText!: string;
  /** Fill the remaining width of a flex toolbar, the way TABLE-EXAMPLE's
   * filter does, instead of using the standalone fixed width. */
  @Prop({ default: false }) fill!: boolean;
  private search = "";

  public clearSearch() {
    this.search = "";
    this.sendSearch();
  }

  @Watch("search")
  public sendSearch(): void {
    this.$emit("submitSearch", this.search);
  }
}
